import React from "react";
import ReactDOM from "react-dom/client";
import "./sentry.client.config";
import "./i18n/i18n";
import App from "./App";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
